export default function getVariantPrice(price) {
  const isPrice = price ?? 0;
  const content = isNaN(Number(price))
    ? price
    : `Starting from €${isPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  return content;
}
